import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";

export default makeStyles((theme: Theme) =>
  createStyles({
    canvas: {
      width: "100%",
      height: "100%",
    },
    uploadIcon: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%,-50%)",
    },
    fileInput: {
      color: "transparent",
      width: "100%",
      height: "100%",
      "&::-webkit-file-upload-button": {
        visibility: "hidden",
      },
    },
    image: {
      position: "absolute",
      top: 0,
      right: 0,
      width: "100%",
      height: "100%",
      visibility: "hidden",
      objectFit: "contain",
      zIndex: 100,
    },
    showImage: {
      visibility: "visible",
    },
    signExample: {
      width: "100%",
      maxWidth: 140,
      maxHeight: 140,
      height: "100%",
      border: "2px dashed #000000",
      marginLeft: "35%",
    },
  })
);
